import { useEffect, useRef } from "react";

export function useInterval(callback, delay) {
  const savedCallback = useRef(null);
  const intervalId = useRef(null);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    if (delay !== null && savedCallback.current) {
      // clear any current interval
      if (intervalId.current) clearInterval(intervalId);

      // Set interval
      intervalId.current = setInterval(() => savedCallback.current(), delay);

      // clean up function called on dismount
      return () => {
        clearInterval(intervalId.current);
        intervalId.current = null;
      };
    }
  }, [delay]);
}

/*
import { useEffect, useRef } from "react";

export function useInterval(callback, delay) {
  const savedCallback = useRef(null);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    if (delay !== null && savedCallback.current) {
      let id = setInterval(() => savedCallback.current(), delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

*/
